import axios from "axios";
import { API_ENDPOINT } from "./resources";

/**
 * Unified merchant invoice dashboard summary API.
 * Payload: { org_token }
 */
export const merchantInvoiceDashboardSummary = async (
  org_token,
  authToken = ""
) => {
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : {};

  const response = await axios.post(
    API_ENDPOINT.merchant_invoice_dashboard_summary,
    { org_token },
    { headers }
  );

  return response?.data || {};
};

